import SEO from "../components/SEO";
import PageHero from "../components/PageHero";
import { Reveal, SectionLabel, Stagger, Item } from "../components/Reveal";
import { FinalCta } from "../components/CTA";
import { useContent, serviceGroups, sortedPackages, pkgPrice } from "../data/siteContent";

export default function Pricing() {
  const content = useContent();
  const groups = serviceGroups
    .map((g) => ({ ...g, items: sortedPackages(content, g.key) }))
    .filter((g) => g.items.length > 0);

  return (
    <div data-testid="pricing-page">
      <SEO title="Pricing — Published Prices, No Hidden Renewals | Allcov" description="Every price published. No hidden renewals, no surprise bills. Logo ₹4,999, Launch Kit ₹14,999, WhatsApp setup ₹5,000." path="/pricing" />
      <PageHero
        eyebrow="Pricing"
        title="Published prices. No hidden renewals."
        line={`Every price below is ${content.gst_note}. GST-registered businesses can claim it back.`}
        testid="pricing"
      />

      <section className="py-20 lg:py-28" data-testid="pricing-tables">
        <div className="mx-auto max-w-5xl space-y-14 px-6 lg:px-10">
          {groups.map((g) => (
            <div key={g.key}>
              <Reveal><SectionLabel>{g.label}</SectionLabel></Reveal>
              <Stagger className="divide-y divide-line border-y border-line">
                {g.items.map((p) => (
                  <Item key={p.id || p.name}>
                    <div className="flex flex-wrap items-baseline justify-between gap-2 py-5" data-testid={`price-row-${p.name.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}>
                      <div>
                        <p className="text-base text-txt md:text-lg">{p.name}</p>
                        {p.note && <p className="mt-1 text-xs text-faint">{p.note}</p>}
                      </div>
                      <p className="font-batangas text-xl tracking-tight text-pop">{pkgPrice(p)}</p>
                    </div>
                  </Item>
                ))}
              </Stagger>
            </div>
          ))}
          <Reveal>
            <p className="text-sm text-mut">Bigger projects (e-commerce, portals, apps): quoted after a call.</p>
          </Reveal>
        </div>
      </section>

      <section className="section-light py-20 lg:py-24" data-testid="pricing-payment">
        <div className="mx-auto max-w-4xl px-6 lg:px-10">
          <Reveal><SectionLabel>How Payment Works</SectionLabel></Reveal>
          <Reveal delay={0.1}>
            <div className="space-y-5 text-sm leading-relaxed text-mut md:text-base">
              <p>50% advance, 50% before go-live. Monthly plans are billed in advance on the 1st. UPI or bank transfer, always with a GST invoice.</p>
              <p>Not included: domain and hosting renewals, paid stock photos, Meta's WhatsApp message charges, ad spend — you pay these directly, at cost, in your own name.</p>
            </div>
          </Reveal>
        </div>
      </section>

      <FinalCta />
    </div>
  );
}
